// extracted by mini-css-extract-plugin
export var actions = "_to-4";
export var item = "_to-1";
export var price = "_to-3";
export var quantity = "_to-2";
export var table = "_to-0";